var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","y":"4","width":"16","height":"4","fill":"#F5F8FB"}}),_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","y":"8","width":"16","height":"4","fill":"#2B9F5A"}}),_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"4","fill":"#DC251C"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }